import script from "./MikatPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MikatPage.vue?vue&type=script&setup=true&lang=js"

import "./MikatPage.vue?vue&type=style&index=0&id=94a3cfc0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94a3cfc0"]])

export default __exports__